<script>
    export let imgProfile, name;
</script>

<div class="flex flex-col items-center py-6 space-y-2 md:space-y-4 lg:space-y-6">		
    <img src="{imgProfile}" alt="foto" class="w-24 md:w-32 lg:w-40 rounded-full object-cover">
    <h1 class="text-xl md:text-2xl lg:text-4xl tracking-tight font-bold">{name}</h1>
    <p class="tracing-wide font-thin text-gray-600 text-xs md:text-sm lg:text-base cursor-default">
        <span class="text-blue-600 hover:text-blue-500">
            UI/UX Designer
        </span> | 
        <span class="text-green-600 hover:text-green-500">
            Student
        </span> | 
        <span class="text-yellow-600 hover:text-yellow-500">
            Frontend Engineer
        </span>
    </p>
</div>